export const TooltipData_Debtor_Creditor = {
  type: 'Type',
  country: 'Country',
  currency: 'Currency',
  organisation: 'Organisation',
  companyName: 'Company Name',
  tradingName: 'Trading Name',
  companyRegistrationNumber: 'Company Registration Number',
  previousName: 'Previous Name',
  address: 'Address',
  address2: 'Address 2',
  city: 'City',
  state: 'State',
  postCode: 'Post Code',
  phoneNumber: 'Phone Number',
  otherNumber: 'Other Number',
  mobileNumber: 'Mobile Number',
  email: 'Email',
  contactFirstName: 'Contact First Name',
  contactLastName: 'Contact Last Name',
  contactPhoneNumber: 'Contact Phone Number',
  contactEmail: 'Contact Email',
  counterPartyYear: 'Loyal Since',
  historicValue: 'Total Historic Value',
  paymentCycle: 'Payment Cycle',
  notesIssued: 'Credit Notes Issued',
  invoices: 'Invoices Predicted Per Annum',
  annualRevenue: 'Predicted Annual Revenue',
  bankName: 'Bank Name',
  iban: 'IBAN',
  swiftCode: 'Swift BIC',
  accountNumber: 'Account Number',
  sortCode: 'Sort Code',
  name: 'Name',
};
